import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { BusinessRounded } from "@mui/icons-material";
import colors from "../../Constants/colors";
import { useTranslation } from "react-i18next";
import { SharedCompany } from "../../Models/company";
import { useTerminology } from "../../Core/useTerminology";

interface SharedEntitiesTableProps {
  companies: SharedCompany[];
}

const SharedEntitiesTable: React.FC<SharedEntitiesTableProps> = ({
  companies,
}) => {
  const { t } = useTranslation("workspaces");
  const terminology = useTerminology();

  if (!companies || companies.length === 0) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: "0.85rem",
              fontWeight: 500,
              color: colors.primary_dark,
              paddingLeft: 2,
            }}
          >
            {t("noCompanies", { entity: terminology.plural })}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      {companies.map((company) => (
        <Grid item key={company.id} xs={12} sm={6} md={4}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              transition: "background-color 0.3s ease",
              "&:hover": { backgroundColor: colors.accent },
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}
              >
                <BusinessRounded
                  sx={{ marginRight: 1, color: colors.primary_dark }}
                />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: colors.primary_dark }}
                >
                  {company.name}
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  marginBottom: 1,
                  color: colors.primary_dark,
                  textTransform: "capitalize",
                }}
              >
                {t("industry")}: {company.industry || t("notAvailable")}
              </Typography>
              <Typography
                variant="body2"
                sx={{ marginBottom: 1, color: colors.primary_dark }}
              >
                {t("location")}: {company.location || t("notAvailable")}
              </Typography>
              <Typography
                variant="body2"
                sx={{ marginBottom: 1, color: colors.primary_dark }}
              >
                {t("owner")}: {company.owner || t("notAvailable")}
              </Typography>

              {company.workspace_shared && (
                <Typography
                  variant="caption"
                  sx={{
                    marginTop: 1,
                    fontWeight: "bold",
                    color: colors.primary_dark,
                    display: "inline-block",
                    border: `1px solid ${colors.primary_dark}`,
                    padding: "2px 6px",
                    borderRadius: 1,
                  }}
                >
                  {t("sharedWithWorkspace")}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SharedEntitiesTable;
